import {html} from "@isceco/widget-library2/external/lit"
import InputColumn from "@isceco/widget-library2/basic-elements/List/column/InputColumn.js"
import '@isceco/widget-library2/basic-elements/Dropdown/Dropdown.js'
import '@isceco/widget-library2/basic-elements/NumberInput/NumberInput.js'

export default class VerordnungVerbrauchergruppeColumns {

  static getColumns(verbGruppeList) {
    return [
      VerordnungVerbrauchergruppeColumns.BRANCHE_COLUMN(verbGruppeList),
      VerordnungVerbrauchergruppeColumns.PROZENTSATZ_COLUMN(),
      VerordnungVerbrauchergruppeColumns.ERSPARNIS_COLUMN()
    ]
  }

  static BRANCHE_COLUMN(verbGruppeList) {
    return new InputColumn({
      key: 'gruppe',
      text: 'verordnung.create.verbrauchergruppe.gruppe',
      render: (i18n, cell, row) => html`
        <isceco-dropdown name="gruppe"
                         value="${cell}"
                         .items="${verbGruppeList}"
                         required
                         readonly
        ></isceco-dropdown>
      `
    })
  }

  static PROZENTSATZ_COLUMN() {
    return new InputColumn({
      key: 'prozentsatz',
      text: 'verordnung.create.verbrauchergruppe.prozentsatz',
      render: (i18n, cell, row) => html`
        <div style="display: flex; align-items: center; gap: 0.5rem;">
          <isceco-number-input name="prozentsatz"
                               value="${cell}"
                               min="0"
                               max="100"
                               maximum-fraction-digits="2"
                               required>
          </isceco-number-input>
          <span>%</span>
        </div>
      `
    })
  }

  static ERSPARNIS_COLUMN() {
    return new InputColumn({
      key: 'ersparnis',
      text: 'verordnung.create.verbrauchergruppe.ersparnis',
      render: (i18n, cell, row) => html`
        <isceco-number-input name="ersparnis"
                             value="${cell}"
                             readonly>
        </isceco-number-input>
      `
    })
  }
}
